import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api"; // ✅ shared axios client (Render + local)

function AddAsset() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    asset_name: "",
    line: "",
    custom_line: "",
    machine_type: "",
    custom_machine_type: "",
    description: "",
  });

  const lines = [
    "Line A","Line B","Line C","Line D","Shirataki","Juten","1Gal","Fryer",
    "Multivac","Building","Production","SQF","Okara","Recieving","Soaking",
    "Casing","Other",
  ];

  const machines = [
    "Silo","Scale unit","Conveyor","Grinder","Cooker","surge Tank","Separator",
    "Turn Table","Steam Tunnel","Morikomi","Traverser","Press Machine",
    "Alkali CV","Pasteurizer","Automation","Topia","Scal","DPX","Boil&cool",
    "Metal Detector","Taper Machine","Packing Machine","Taper Machine",
    "Boiler","Compressor","Chiller","Cooling tower","HVAC","Cooler","Other",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      asset_name: formData.asset_name,
      line: formData.line === "Other" ? formData.custom_line : formData.line,
      machine_type:
        formData.machine_type === "Other"
          ? formData.custom_machine_type
          : formData.machine_type,
      description: formData.description,
    };

    // Optional: remove custom fields
    // (backend doesn't need them)
    // payload has only real DB fields

    try {
      await api.post("/api/assets", payload);
      alert("✅ Asset created successfully!");
      navigate("/all-assets", { replace: true });
    } catch (err) {
      console.error("❌ Failed to create asset:", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err.message ||
        "Unknown error";
      alert(`❌ Failed to create asset: ${msg}`);
    }
  };

  return (
    <div className="main-content">
      <h1>➕ Add New Asset</h1>

      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="asset_name">Asset Name:</label>
          <input
            id="asset_name"
            name="asset_name"
            value={formData.asset_name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="line">Line:</label>
          <select
            id="line"
            name="line"
            value={formData.line}
            onChange={handleChange}
            required
          >
            <option value="">Select Line</option>
            {lines.map((l) => (
              <option key={l} value={l}>
                {l}
              </option>
            ))}
          </select>

          {formData.line === "Other" && (
            <div>
              <label htmlFor="custom_line">Custom Line:</label>
              <input
                id="custom_line"
                name="custom_line"
                value={formData.custom_line}
                onChange={handleChange}
                required
              />
            </div>
          )}
        </div>

        <div>
          <label htmlFor="machine_type">Machine Type:</label>
          <select
            id="machine_type"
            name="machine_type"
            value={formData.machine_type}
            onChange={handleChange}
            required
          >
            <option value="">Select Machine</option>
            {machines.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>

          {formData.machine_type === "Other" && (
            <div>
              <label htmlFor="custom_machine_type">Custom Machine Type:</label>
              <input
                id="custom_machine_type"
                name="custom_machine_type"
                value={formData.custom_machine_type}
                onChange={handleChange}
                required
              />
            </div>
          )}
        </div>

        <div>
          <label htmlFor="description">Description:</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        <br />
        <button type="submit">Submit Asset</button>
      </form>
    </div>
  );
}

export default AddAsset;
